import { IconButton, TableCell, Tooltip } from "@mui/material";
import { ContentPaste } from "@mui/icons-material";
import { useSessionContext } from "../../../../../contexts/SessionContext";

export function ProblemsActions({
  row,
  openVisualizer,
  verifyVisualizer,
}: any) {
  const { access } = useSessionContext();
  return (
    <TableCell align="center">
      {verifyVisualizer &&
        access?.type === "professional" && (
          <Tooltip title="Visualizar atendimento">
            <IconButton
              onClick={() => {
                // Se for um item personalizado, extrai apenas o ID do encontro da referência
                let encounterId;
                if (row?.isCustom && row?.encounterRef) {
                  // Para itens personalizados, extrai apenas o ID da referência (formato "Encounter/123")
                  encounterId = row.encounterRef.split("/")[1];
                } else {
                  // Para itens normais, já temos o ID do encontro
                  encounterId = row.encounterId;
                }
                
                openVisualizer(encounterId);
              }}
            >
              <ContentPaste />
            </IconButton>
          </Tooltip>
        )}
    </TableCell>
  );
}
